import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Gameplay } from "appworks/model/gameplay/gameplay";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { Exit } from "appworks/state-machine/data/exit";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { AutoplayService } from "slotworks/services/autoplay/autoplay-service";
import { RequestSpinState } from "slotworks/state-machine/standard/states/request-spin-state";

export class GameiomRequestSpinState extends RequestSpinState {
    protected oldGame: Gameplay = null;

    public onEnter(cascadeSkip?: boolean) {
        this.oldGame = gameState.getCurrentGame();

        super.onEnter(cascadeSkip);
    }

    /**
     * This function intentionally avoids calling super.error()
     */
    public error() {
        Components.get(AbstractMatrixComponent).reset();
        Services.get(AutoplayService).stop();
        Services.get(SoundService).stopAllPlayingSounds();

        uiFlags.set(UIFlag.NO_SKIP, false);
        gameWrapper.setIdle();

        this.oldGame.balance = gameState.getCurrentGame().balance;
        gameState.setGameplay(this.oldGame);

        this.cancelGroup.clear();
        this.stateMachine.changeState(Exit.Error, this);
    }

    protected startSpinning(): Contract<void> {
        return new Sequence([
            () => Contract.wrap(() => {
                gameWrapper.winningsUpdate(0);
                gameWrapper.setBusy();
            }),
            () => super.startSpinning()
        ]);
    }
}
